import { UserManager } from 'oidc-client-ts';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import App from './App';
import { AppContext } from './AppContext';
import { Loader } from './core/components';
import { fetchApplicationSettings, fetchLanguages, fetchStartupToken, fetchTranslations } from './core/dispatches';
import excludeRoutes from './core/helpers/excludeRoutes';
import { IStore } from './core/reducers/IStore';
import SessionStorageService from './core/services/SessionStorageService';
import { IDictionary } from './core/types/IDictionary';
import { LanguageCode } from './core/types/ILanguage';
import { ITranslationCollection } from './core/types/ITranslationCollection';
import UserManagerService from './core/services/UserManagerService';

type Props = {
    fetchApplicationSettings: () => void,
    fetchTranslations: (currentLanguage: string) => void,
    fetchStartupToken: (customerId: string) => void,
    translations: IDictionary<ITranslationCollection>
}

const AppLoader = (props: Props) => {
    const [isDataLoading, setDataIsLoading] = useState<boolean>(true);
    const [userManager, setUserManager] = useState<UserManager>();
    const [languages, setLanguages] = useState<any>();
    const [currentLanguage, setcurrentLanguage] = useState<string>();

    const load = async () => {
        setDataIsLoading(true);

        try {
            const currentLanguage = SessionStorageService.get('selectedLanguage') || '';
            const languages = await fetchLanguages();

            setcurrentLanguage(currentLanguage);
            setLanguages(languages);

            await props.fetchApplicationSettings();
            await props.fetchTranslations(currentLanguage);
            await userManager?.getUser();
        } finally {
            setDataIsLoading(false);
        }
    }

    useEffect(() => {
        const sessionLanguage = SessionStorageService.get('selectedLanguage') as string;

        if (sessionLanguage && sessionLanguage !== currentLanguage) {
            SessionStorageService.set('selectedLanguage', sessionLanguage as LanguageCode);
        }

        setUserManager(UserManagerService);

        if (!excludeRoutes(window.location)) {
            load();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentLanguage]);

    return (
        ((isDataLoading && !excludeRoutes(window.location)) || !userManager) ? (
            <Loader main={true} opacity={1} />
        ) : (
                <AppContext.Provider value={{
                    languages,
                    currentLanguage
                }}>
                    <App userManager={userManager} />
                </AppContext.Provider>
            )
    )
}

const mapStateToProps = (state: IStore) => ({
    translations: state.translations
})

const mapDispatchToProps = (dispatch: ThunkDispatch<IStore, void, AnyAction>) => ({
    fetchTranslations: (currentLanguage: string) => dispatch(fetchTranslations(currentLanguage)),
    fetchApplicationSettings: () => dispatch(fetchApplicationSettings()),
    fetchStartupToken: (customerId: string) => dispatch(fetchStartupToken(customerId))
});

export default connect(mapStateToProps, mapDispatchToProps)(AppLoader);